<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">線上點餐管理 / 套餐管理</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
          <router-link :to="{ name: 'combo_add', params: { search: search } }" class="btn btn-normal-ptc1" tag="button" v-if="FunctionPermission > 1">新增套餐</router-link>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row mt-3">
                  <label class="control-label col-md-2">套餐名稱：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.name" placeholder="請輸入關鍵字搜尋">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <h3></h3>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>項次</th>
                            <th>圖片</th>
                            <th>套餐名稱</th>
                            <th>販售對象</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{search.pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td><img height="140px" :src="x.ImageURL"></td>
                            <td>{{x.Name}}</td>
                            <td>{{ (x.MemberType===1) ? '全部會員':'正式會員'}}</td>
                            <td>
                              <router-link v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" tag="button" :to="{ name: 'combo_edit', params: { item: x, action: 1, search: search } }" v-if="FunctionPermission > 1"><span class="fa fa-pencil-alt"></span></router-link>
                              <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="showDelete(x)" v-if="FunctionPermission > 1"><span class="fas fa-trash-alt"></span></button>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="search.totalRows" v-model="search.currentPage" :per-page="search.pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalRows}}筆</label>
                    </div>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer size='lg' title='套餐明細'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-7">
              <div class='row mb-3'>
                <label class='control-label col-md-3'>代碼：</label>
                  <div class='col-md-7'>
                    {{md_item.ID}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>餐點名稱：</label>
                  <div class='col-md-7'>
                    {{md_item.Name}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售週期：</label>
                  <div class='col-md-7'>
                    <b-form-group>
                      <b-form-checkbox-group disabled v-model="md_week" :options="optionsWeek" ></b-form-checkbox-group>
                    </b-form-group>
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售對象：</label>
                  <div class='col-md-7'>
                    {{ (md_item.MemberType===1) ? '全部會員':'正式會員'}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>備註：</label>
                  <div class='col-md-7'>
                    {{md_item.Memo}}{{md_item.UpdatedName}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>主餐品項：</label>
                  <div class='col-md-7'>
                    {{md_item.ProductName}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>主餐折扣：</label>
                  <div class='col-md-7'>
                    {{md_item.MainDiscount}}
                  </div>
              </div>
            </div>
            <div class="col-lg-5">
                <img class="bk_img" :src="md_imgUrl">
            </div>
          </div>
          <div class="row">
            <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>項次</th>
                            <th>APP顯示文字</th>
                            <th>折扣金額</th>
                            <th>是否必選</th>
                            <th>搭配型態</th>
                            <th>POS類別</th>
                            <th>預設商品</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in lists" :key="x.ComboOptionID" :id="x.ComboOptionID">
                            <td>{{index + 1}}</td>
                            <td>{{x.AppShowWord}}</td>
                            <td>{{x.Discount}}</td>
                            <td><div v-if="x.IsRequired">是</div><div v-else>否</div></td>
                            <td><div v-if="x.OptionType==1">單品</div><div v-else>POS分類</div></td>
                            <td>{{x.OptionProduct}}</td>
                            <td>{{x.DefaultProduct.Name}}</td>
                          </tr>
                        </tbody>
                      </table>
          </div>
        </b-container>
      </b-modal>
      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="套餐刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除套餐 {{md_title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      search: {
        code: '',
        name: '',
        currentPage: 1,
        pageRows: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0
      },
      totalRows: 0,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_id: 0,
      md_title: '',
      md_imgUrl: undefined,
      md_week: [],
      md_item: [],
      md_OptionProducts: '',
      API_URL: API_URL,
      FunctionPermission: 0,
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      lists: []
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F17') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      console.log(this.search)
      this.query()
    } else {
      this.reset()
    }
  },
  methods: {
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.currentPage = 1

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      var name, code, page, pageRows

      name = this.search.name
      code = this.search.code
      page = this.search.currentPage
      pageRows = this.search.pageRows

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getpagecombo/v1', {
        code: code,
        name: name,
        page: page,
        pageRows: pageRows
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.search.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = this.search.currentPage // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.search.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.search.pageRows * (this.search.currentPage - 1) + 1;
            this.search.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.search.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.search.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.search.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    showDetail (item) {
      this.md_week = JSON.parse('[' + item.Week + ']');
      this.md_item = item
      this.md_imgUrl = item.ImageURL
      this.getOption(item.ID)
      this.$refs.mdDetail.show()
    },
    showDelete (item) {
      this.md_id = item.ID
      this.md_title = item.Title
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/deletecombo/v1', {
        id: this.md_id
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('套餐已刪除')
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    getOption (ID) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getComboOptions/v1', {
        status: ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.lists = response.data.data
            for (var p in response.data.data) {
              var product = ''
              for (var i in response.data.data[p].OptionProduct) {
                if (i === '0') {
                  product = response.data.data[p].OptionProduct[i].Name
                } else {
                  product = product + '、' + response.data.data[p].OptionProduct[i].Name
                }
              }
              this.lists[p].OptionProduct = product
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '搭配資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '搭配資料讀取異常2')
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/combo/List.vue